import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { FavoriteTest } from '../pages/orders/modules/order/models/favorite-test.model';

@Injectable({ providedIn: 'root' })
export class FavoriteTestsApiService {
  private readonly baseUrl = environment.apiUrl;
  private readonly httpClient = inject(HttpClient);

  public getFavoriteTests(practiceId: number, laboratoryFacilityId: number): Observable<FavoriteTest[]> {
    return this.httpClient.get<FavoriteTest[]>(
      `${this.baseUrl}/search/tests/favorites?practiceId=${practiceId}&laboratoryFacilityId=${laboratoryFacilityId}`
    );
  }
}
